import { IScale } from './IScale';
import { LinearScale } from './LinearScale';

export class HorizontalScale extends LinearScale implements IScale {
    private _width: number;

    constructor(width: number, min: number, max: number) {
        super(min, max);
        this.width(width);
    }

    size(value?: number): number {
        return this.width(value);
    }

    width(value?: number): number {
        if (value) {
            this._width = value;
            this.scale().range([0, this.width()]);
        }
        return this._width;
    }
}